import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Scorecard as ScorecardType, ScorecardListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const SCORECARD_FIELDS = `createdDate grouping id name orgId updatedDate version workspaceId objectIds dateRange lookbackType lookbackAmount columnVisibility columnOrder sort default`

const LIST_QUERY = graphql(`
  query Scorecards($search: String, $pagination: PaginationInput, $sort: SortInput) {
    scorecards(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        objectIds
        dateRange
        lookbackType
        lookbackAmount
        columnVisibility
        columnOrder
        sort
        default
        createdDate
        grouping
        id
        name
        orgId
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateScorecardStore($input: CreateScorecardInput!) {
    createScorecard(input: $input) {
      objectIds
      dateRange
      lookbackType
      lookbackAmount
      columnVisibility
      columnOrder
      sort
      default
      createdDate
      grouping
      id
      name
      orgId
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateScorecardStore($id: ID!, $input: UpdateScorecardInput!) {
    updateScorecard(id: $id, input: $input) {
      objectIds
      dateRange
      lookbackType
      lookbackAmount
      columnVisibility
      columnOrder
      sort
      default
      createdDate
      grouping
      id
      name
      orgId
      updatedDate
      version
      workspaceId
    }
  }
`)

export class ScorecardStore extends EntityStore<
  ScorecardType,
  ScorecardListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: undefined,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      extractList: (data: any) => data.scorecards,
      extractMutated: (data: any) => data.updateScorecard ?? data.createScorecard,
    })
  }
}
